<!-- Waybill Detail Popup -->
<div class="popup-overlay" [class.show]="visible" (click)="close()">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h4 class="popup-title">
        <i class="fas me-2" [ngClass]="type === 'ragione-sociale' ? 'fa-building' : 'fa-barcode'"></i>
        Dettagli {{ displayType }}
      </h4>
      <button type="button" class="btn-close" (click)="close()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Tabs Navigation -->
    <div class="popup-tabs">
      <button type="button"
              class="tab-btn"
              [class.active]="activeTab === 'details'"
              (click)="setActiveTab('details')">
        <i class="fas fa-info-circle me-2"></i>
        Dettagli
      </button>
      <button type="button"
              class="tab-btn"
              [class.active]="activeTab === 'events'"
              (click)="setActiveTab('events')"
              *ngIf="type !== 'ragione-sociale'">
        <i class="fas fa-history me-2"></i>
        Eventi
      </button>
      <button type="button"
              class="tab-btn"
              [class.active]="activeTab === 'webhooks'"
              (click)="setActiveTab('webhooks')"
              *ngIf="type !== 'ragione-sociale'">
        <i class="fas fa-plug me-2"></i>
        Webhook
      </button>
      <button type="button"
              class="tab-btn"
              [class.active]="activeTab === 'images'"
              (click)="setActiveTab('images')"
              *ngIf="type !== 'ragione-sociale'">
        <i class="fas fa-images me-2"></i>
        Immagini
      </button>
      <button type="button"
              class="tab-btn"
              [class.active]="activeTab === 'barcode'"
              (click)="setActiveTab('barcode')"
              *ngIf="type !== 'ragione-sociale'">
        <i class="fas fa-barcode me-2"></i>
        Barcode/QR
      </button>
      <button type="button"
              class="tab-btn"
              [class.active]="activeTab === 'map'"
              (click)="setActiveTab('map')">
        <i class="fas fa-map-marker-alt me-2"></i>
        Mappa
      </button>
      <button type="button" 
              class="tab-btn" 
              [class.active]="activeTab === 'functions'"
              (click)="setActiveTab('functions')">
        <i class="fas fa-cogs me-2"></i>
        Funzionalità
      </button>
    </div>

    <div class="popup-body">
      <!-- Tab: Dettagli -->
      <div class="tab-content" *ngIf="activeTab === 'details'">
        <div class="waybill-details">

          <!-- Header riepilogo -->
          <div class="details-summary" *ngIf="waybill">
            <div class="details-summary-item">
              <i class="fas fa-file-invoice"></i>
              <span>Bolla: <strong>{{ waybill?.waybillCode || displayCode || '-' }}</strong></span>
            </div>
            <div class="details-summary-item" *ngIf="waybill?.waybillTotalParcels">
              <i class="fas fa-boxes"></i>
              <span><strong>{{ waybill?.waybillTotalParcels }}</strong> colli</span>
            </div>
            <div class="details-summary-item" *ngIf="waybill?.waybillStatus">
              <span class="details-status-badge"
                    [ngClass]="isDelivered() ? 'status-executed' : 'status-in-progress'">
                <i class="fas fa-circle status-dot"></i>
                {{ waybill?.waybillStatus }}
              </span>
            </div>
            <div class="details-summary-item" *ngIf="isLate()">
              <span class="details-status-badge status-late">
                <i class="fas fa-exclamation-triangle me-1"></i>
                In Ritardo
              </span>
            </div>
          </div>

          <!-- Sezione Stato e Consegna -->
          <div class="details-card"
               *ngIf="waybill"
               [class.is-delivered]="isDelivered()">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-truck"></i>
              </div>
              <h5 class="details-card-title">Stato e Consegna</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item">
                  <span class="details-label">Stato</span>
                  <div class="details-value">
                    <span class="details-status-badge"
                          *ngIf="waybill?.waybillStatus; else noWaybillStatus"
                          [ngClass]="isDelivered() ? 'status-executed' : 'status-in-progress'">
                      <i class="fas fa-circle status-dot"></i>
                      {{ waybill?.waybillStatus }}
                    </span>
                    <ng-template #noWaybillStatus><span class="text-muted">-</span></ng-template>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Metodo Consegna</span>
                  <div class="details-value">{{ waybill?.waybillDeliveryMethod || '-' }}</div>
                </div>
                <div class="details-item">
                  <span class="details-label">Tipo Consegna</span>
                  <div class="details-value">{{ waybill?.waybillDeliveryType || '-' }}</div>
                </div>
                <div class="details-item">
                  <span class="details-label">Data Consegna</span>
                  <div class="details-value">
                    <ng-container *ngIf="waybill?.waybillActualDeliveryDate; else noActualDelivery">
                      <i class="fas fa-check-circle text-success me-1"></i>
                      {{ waybill?.waybillActualDeliveryDate | date:'dd/MM/yyyy HH:mm' }}
                    </ng-container>
                    <ng-template #noActualDelivery>
                      <span class="details-status-badge status-in-progress">
                        <i class="fas fa-circle status-dot"></i>
                        In Consegna
                      </span>
                    </ng-template>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Data Prevista</span>
                  <div class="details-value">
                    <span>{{ waybill?.waybillEstimatedDeliveryDate ? (waybill?.waybillEstimatedDeliveryDate | date:'dd/MM/yyyy HH:mm') : '-' }}</span>
                    <button type="button"
                            class="btn btn-sm btn-outline-primary ms-2"
                            (click)="recalculateEstimatedDeliveryDate()"
                            [disabled]="isRecalculating"
                            title="Ricalcola data prevista di consegna">
                      <i class="fas" [ngClass]="isRecalculating ? 'fa-spinner fa-spin' : 'fa-sync-alt'"></i>
                    </button>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Tempo Transito</span>
                  <div class="details-value">
                    <i class="fas fa-clock me-1 text-muted" *ngIf="waybill?.waybillTransitTimeHours"></i>
                    {{ waybill?.waybillTransitTimeHours ? (waybill?.waybillTransitTimeHours + ' ore') : '-' }}
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Causale Consegna</span>
                  <div class="details-value">{{ waybill?.waybillDeliveryReason || '-' }}</div>
                </div>
                <div class="details-item">
                  <span class="details-label">Tipo Creazione</span>
                  <div class="details-value">{{ waybill?.waybillCreateType || '-' }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Date -->
          <div class="details-card" *ngIf="waybill">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-calendar"></i>
              </div>
              <h5 class="details-card-title">Date</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item">
                  <span class="details-label">Data Bolla</span>
                  <div class="details-value">
                    <i class="fas fa-calendar-day me-1 text-muted"></i>
                    {{ waybill?.waybillDate ? (waybill?.waybillDate | date:'dd/MM/yyyy HH:mm') : '-' }}
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Creata il</span>
                  <div class="details-value">
                    <i class="fas fa-calendar-plus me-1 text-muted"></i>
                    {{ waybill?.waybillCreatedAt ? (waybill?.waybillCreatedAt | date:'dd/MM/yyyy HH:mm') : '-' }}
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Ultimo Aggiornamento</span>
                  <div class="details-value">
                    <i class="fas fa-history me-1 text-muted"></i>
                    {{ waybill?.waybillUpdatedAt ? (waybill?.waybillUpdatedAt | date:'dd/MM/yyyy HH:mm') : '-' }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Identificazione Bolla -->
          <div class="details-card">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-file-invoice"></i>
              </div>
              <h5 class="details-card-title">Identificazione Bolla</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item">
                  <span class="details-label">Codice Bolla</span>
                  <div class="details-value details-value--code">
                    <span>{{ waybill?.waybillCode || displayCode || '-' }}</span>
                    <i *ngIf="waybill?.waybillCode || displayCode"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(waybill?.waybillCode || displayCode)"
                       title="Copia codice bolla"></i>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Tracking Number</span>
                  <div class="details-value details-value--code">
                    <span>{{ waybill?.waybillTrackingNumber || '-' }}</span>
                    <i *ngIf="waybill?.waybillTrackingNumber"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(waybill?.waybillTrackingNumber)"
                       title="Copia tracking"></i>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Codice Spedizione</span>
                  <div class="details-value details-value--code">
                    <span>{{ waybill?.waybillShipmentCode || '-' }}</span>
                    <i *ngIf="waybill?.waybillShipmentCode"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(waybill?.waybillShipmentCode)"
                       title="Copia codice spedizione"></i>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Codice Pallet</span>
                  <div class="details-value details-value--code">
                    <span>{{ waybill?.waybillPalletCode || '-' }}</span>
                    <i *ngIf="waybill?.waybillPalletCode"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(waybill?.waybillPalletCode)"
                       title="Copia codice pallet"></i>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Bolla Originale</span>
                  <div class="details-value details-value--code">
                    <span>{{ waybill?.waybillOriginalWaybillCode || '-' }}</span>
                    <i *ngIf="waybill?.waybillOriginalWaybillCode"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(waybill?.waybillOriginalWaybillCode)"
                       title="Copia codice bolla originale"></i>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Codice Routing Esterno</span>
                  <div class="details-value details-value--code">
                    <span>{{ waybill?.waybillExternalRoutingCode || '-' }}</span>
                    <i *ngIf="waybill?.waybillExternalRoutingCode"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(waybill?.waybillExternalRoutingCode)"
                       title="Copia codice routing esterno"></i>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Baia di Carico</span>
                  <div class="details-value">{{ waybill?.waybillLoadingBay || '-' }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Località -->
          <div class="details-card" *ngIf="waybill">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-map-marked-alt"></i>
              </div>
              <h5 class="details-card-title">Località</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item">
                  <span class="details-label">Origine</span>
                  <div class="details-value">
                    <i class="fas fa-map-marker-alt me-1 text-muted"></i>
                    {{ getWarehouseName(waybill?.waybillOriginLocation) }}
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Destinazione</span>
                  <div class="details-value">
                    <i class="fas fa-flag-checkered me-1 text-muted"></i>
                    {{ getWarehouseName(waybill?.waybillDestinationLocation) }}
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Ultima Posizione</span>
                  <div class="details-value">
                    <i class="fas fa-location-arrow me-1 text-muted"></i>
                    {{ waybill?.waybillLastKnownLocation || '-' }}
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Origine Last Mile</span>
                  <div class="details-value">
                    <i class="fas fa-warehouse me-1 text-muted"></i>
                    {{ getWarehouseName(waybill?.waybillLastMileOrigin) }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Carico -->
          <div class="details-card" *ngIf="waybill">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-boxes"></i>
              </div>
              <h5 class="details-card-title">Informazioni Carico</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid details-grid--metrics">
                <div class="details-metric">
                  <i class="fas fa-weight-hanging metric-icon"></i>
                  <div class="metric-text">
                    <span class="details-label">Peso Totale</span>
                    <div class="details-value">{{ waybill?.waybillTotalWeight ? (waybill?.waybillTotalWeight + ' kg') : '-' }}</div>
                  </div>
                </div>
                <div class="details-metric">
                  <i class="fas fa-cube metric-icon"></i>
                  <div class="metric-text">
                    <span class="details-label">Volume Totale</span>
                    <div class="details-value">{{ waybill?.waybillTotalVolume ? (waybill?.waybillTotalVolume + ' m³') : '-' }}</div>
                  </div>
                </div>
                <div class="details-metric">
                  <i class="fas fa-box metric-icon"></i>
                  <div class="metric-text">
                    <span class="details-label">Numero Colli</span>
                    <div class="details-value">{{ waybill?.waybillTotalParcels || '-' }}</div>
                  </div>
                </div>
              </div>
              <div class="details-grid mt-3">
                <div class="details-item">
                  <span class="details-label">Fragile</span>
                  <div class="details-value">
                    <span class="details-pill type-urgent" *ngIf="waybill?.waybillFragile === 'Y'">
                      <i class="fas fa-exclamation-triangle me-1"></i>Sì
                    </span>
                    <span *ngIf="waybill?.waybillFragile === 'N'">No</span>
                    <span *ngIf="!waybill?.waybillFragile" class="text-muted">-</span>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Materiale Pericoloso</span>
                  <div class="details-value">
                    <span class="details-pill type-urgent" *ngIf="waybill?.waybillHazardousMaterial === 'Y'">
                      <i class="fas fa-radiation me-1"></i>Sì
                    </span>
                    <span *ngIf="waybill?.waybillHazardousMaterial === 'N'">No</span>
                    <span *ngIf="!waybill?.waybillHazardousMaterial" class="text-muted">-</span>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Sdoganamento</span>
                  <div class="details-value">
                    <span class="details-pill" *ngIf="waybill?.waybillCustomsClearanceRequired === 'Y'">
                      <i class="fas fa-stamp me-1"></i>Richiesto
                    </span>
                    <span *ngIf="waybill?.waybillCustomsClearanceRequired === 'N'">Non Richiesto</span>
                    <span *ngIf="!waybill?.waybillCustomsClearanceRequired" class="text-muted">-</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Dealer -->
          <div class="details-card details-card--dealer"
               [class.is-delivered]="isDelivered()">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-store"></i>
              </div>
              <h5 class="details-card-title">
                Destinatario (Dealer)
                <span class="details-card-tag" *ngIf="isDelivered()">
                  <i class="fas fa-check me-1"></i>Consegnato
                </span>
              </h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item">
                  <span class="details-label">Codice Dealer</span>
                  <div class="details-value details-value--code">
                    <span>{{ dealer?.dealerCode || '-' }}</span>
                    <i *ngIf="dealer?.dealerCode"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(dealer?.dealerCode)"
                       title="Copia codice dealer"></i>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Nome</span>
                  <div class="details-value">{{ dealer?.dealerName || '-' }}</div>
                </div>
                <div class="details-item">
                  <span class="details-label">Ragione Sociale</span>
                  <div class="details-value">{{ dealer?.dealerLegalName || '-' }}</div>
                </div>
                <div class="details-item">
                  <span class="details-label">Dealer Destinatario</span>
                  <div class="details-value details-value--code">
                    <span>{{ waybill?.waybillDealerCodeReceiver || '-' }}</span>
                    <i *ngIf="waybill?.waybillDealerCodeReceiver"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(waybill?.waybillDealerCodeReceiver)"
                       title="Copia codice dealer destinatario"></i>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Dealer Originale</span>
                  <div class="details-value details-value--code">
                    <span>{{ waybill?.waybillDealerCodeOriginal || '-' }}</span>
                    <i *ngIf="waybill?.waybillDealerCodeOriginal"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(waybill?.waybillDealerCodeOriginal)"
                       title="Copia codice dealer originale"></i>
                  </div>
                </div>
                <div class="details-item details-item--wide">
                  <span class="details-label">Indirizzo</span>
                  <div class="details-value">
                    <ng-container *ngIf="dealer?.dealerOperatingAddressStreet || dealer?.dealerOperatingAddressCity; else noAddr">
                      <div>
                        <i class="fas fa-road me-1 text-muted"></i>
                        {{ dealer?.dealerOperatingAddressStreet }} {{ dealer?.dealerOperatingAddressNumber }}
                      </div>
                      <div>
                        <i class="fas fa-city me-1 text-muted"></i>
                        {{ dealer?.dealerOperatingAddressZip }} {{ dealer?.dealerOperatingAddressCity }}
                        <ng-container *ngIf="dealer?.dealerOperatingAddressProvince">
                          ({{ dealer?.dealerOperatingAddressProvince }})
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-template #noAddr><span class="text-muted">-</span></ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Alias Indirizzo -->
          <div class="details-card" *ngIf="waybill">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-tag"></i>
              </div>
              <h5 class="details-card-title">Alias Indirizzo</h5>
            </div>
            <div class="details-card-body">
              <div class="details-notes" style="font-weight: 700; color: #000;">
                {{ waybill?.waybillAddressAlias || '-' }}
              </div>
            </div>
          </div>

          <!-- Sezione Gestione -->
          <div class="details-card" *ngIf="waybill">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-building"></i>
              </div>
              <h5 class="details-card-title">Gestione</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item">
                  <span class="details-label">Brand</span>
                  <div class="details-value">
                    <i class="fas fa-tag me-1 text-muted"></i>
                    {{ getBrandName(waybill?.waybillBrandCode) }}
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Vettore</span>
                  <div class="details-value">
                    <i class="fas fa-truck-moving me-1 text-muted"></i>
                    {{ getCarrierName(waybill?.waybillCarrierCode) }}
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Aggiornato da</span>
                  <div class="details-value">
                    <i class="fas fa-user me-1 text-muted"></i>
                    {{ waybill?.waybillUpdatedBy || '-' }}
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Vettore Pianificato</span>
                  <div class="details-value">
                    <i class="fas fa-truck me-1 text-muted"></i>
                    {{ getCarrierName(waybill?.waybillPlannedCarrierCode) }}
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Vettore Sistema Esterno</span>
                  <div class="details-value">
                    <i class="fas fa-truck me-1 text-muted"></i>
                    {{ getCarrierName(waybill?.waybillExternalSystemCarrierCode) }}
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Allegati DDT</span>
                  <div class="details-value">{{ waybill?.waybillDdtAttachments || '-' }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Pianificazione -->
          <div class="details-card" *ngIf="waybill">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-calendar-check"></i>
              </div>
              <h5 class="details-card-title">Pianificazione</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item">
                  <span class="details-label">Tipo Pianificazione</span>
                  <div class="details-value">{{ waybill?.waybillScheduleType || '-' }}</div>
                </div>
                <div class="details-item">
                  <span class="details-label">Consegna Notturna</span>
                  <div class="details-value">
                    <span class="details-pill" *ngIf="waybill?.waybillIsScheduleNight === 'Y'">
                      <i class="fas fa-moon me-1"></i>Sì
                    </span>
                    <span *ngIf="waybill?.waybillIsScheduleNight === 'N'">No</span>
                    <span *ngIf="!waybill?.waybillIsScheduleNight" class="text-muted">-</span>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Priorità Pianificazione</span>
                  <div class="details-value">{{ waybill?.waybillSchedulesPriority || '-' }}</div>
                </div>
                <div class="details-item details-item--wide">
                  <span class="details-label">Condizioni Pianificazione</span>
                  <div class="details-value">{{ waybill?.waybillSchedulesConditions || '-' }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Note -->
          <div class="details-card" *ngIf="waybill">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-sticky-note"></i>
              </div>
              <h5 class="details-card-title">Note</h5>
            </div>
            <div class="details-card-body">
              <div class="details-notes">
                {{ waybill?.waybillNote || '-' }}
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Tab: Eventi -->
      <div class="tab-content" *ngIf="activeTab === 'events'">
        <div class="events-section">

          <!-- Loading state -->
          <div class="events-state-box" *ngIf="isLoadingEvents">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Caricamento...</span>
            </div>
            <p class="mt-3 text-muted mb-0">Caricamento eventi...</p>
          </div>

          <!-- Empty state -->
          <div class="events-state-box" *ngIf="!isLoadingEvents && waybillEvents.length === 0">
            <i class="fas fa-history fa-3x text-muted mb-3"></i>
            <p class="text-muted mb-0">Nessun evento disponibile per questa bolla.</p>
          </div>

          <!-- Header riepilogo -->
          <div class="events-summary" *ngIf="!isLoadingEvents && waybillEvents.length > 0">
            <div class="events-summary-item">
              <i class="fas fa-history"></i>
              <span><strong>{{ waybillEvents.length }}</strong> {{ waybillEvents.length === 1 ? 'evento' : 'eventi' }}</span>
            </div>
            <div class="events-summary-item" *ngIf="lastEventDate">
              <i class="fas fa-clock"></i>
              <span>Ultimo evento: <strong>{{ lastEventDate | date:'dd/MM/yyyy HH:mm' }}</strong></span>
            </div>
          </div>

          <!-- Timeline eventi (il più recente in cima) -->
          <div class="events-timeline" *ngIf="!isLoadingEvents && waybillEvents.length > 0">
            <div class="event-item"
                 *ngFor="let event of waybillEvents; let i = index; let isLast = last"
                 [class.is-last]="isLast">

              <!-- Marker laterale: dot + connettore -->
              <div class="event-marker">
                <div class="event-marker-dot" [ngClass]="getEventVariantClass(event)">
                  <i class="fas" [ngClass]="getEventIcon(event)"></i>
                </div>
                <div class="event-connector" *ngIf="!isLast"></div>
              </div>

              <!-- Corpo evento -->
              <div class="event-body">
                <div class="event-header">
                  <span class="event-title">
                    {{ getEventLabel(event) }}
                    <span class="event-raw-name"
                          *ngIf="event.waybillComplementaryName && getEventLabel(event) !== event.waybillComplementaryName">
                      {{ event.waybillComplementaryName | lowercase }}
                    </span>
                  </span>
                  <span class="event-date" *ngIf="event.waybillComplementaryCreatedAt">
                    <i class="far fa-clock me-1"></i>
                    {{ event.waybillComplementaryCreatedAt | date:'dd/MM/yyyy HH:mm' }}
                  </span>
                </div>
                <div class="event-meta">
                  <span class="event-status-badge" [ngClass]="getEventStatusClass(event)"
                        *ngIf="event.waybillComplementaryStatus">
                    <i class="fas fa-circle status-dot"></i>
                    {{ event.waybillComplementaryStatus }}
                  </span>
                  <span class="event-type-badge" *ngIf="event.waybillComplementaryType">
                    {{ event.waybillComplementaryType }}
                  </span>
                  <span class="event-meta-item" *ngIf="event.waybillComplementaryCreatedBy">
                    <i class="fas fa-user"></i> {{ event.waybillComplementaryCreatedBy }}
                  </span>
                </div>
                <div class="event-note" *ngIf="event.waybillComplementaryValueClob">
                  <i class="fas fa-sticky-note me-1"></i>{{ getEventNote(event, i) }}
                  <button type="button" class="event-note-toggle"
                          *ngIf="isEventNoteTruncatable(event)"
                          (click)="toggleEventNote(i)">
                    {{ isEventNoteExpanded(i) ? 'Mostra meno' : 'Mostra di più' }}
                  </button>
                </div>
                <div class="event-value" *ngIf="getEventValue(event)">
                  <i class="fas fa-info-circle me-1"></i>{{ getEventValue(event) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab: Immagini -->
      <div class="tab-content" *ngIf="activeTab === 'images'">
        <div class="images-section">

          <!-- Loading state -->
          <div class="events-state-box" *ngIf="isLoadingImages">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Caricamento...</span>
            </div>
            <p class="mt-3 text-muted mb-0">Caricamento immagini...</p>
          </div>

          <!-- Empty state -->
          <div class="events-state-box" *ngIf="!isLoadingImages && images.length === 0">
            <i class="fas fa-images fa-3x text-muted mb-3"></i>
            <p class="text-muted mb-0">Nessuna immagine disponibile per questa bolla.</p>
          </div>

          <!-- Toolbar: riepilogo + toggle vista -->
          <div class="routing-toolbar" *ngIf="!isLoadingImages && images.length > 0">
            <div class="routing-summary">
              <div class="routing-summary-item">
                <i class="fas fa-images"></i>
                <span><strong>{{ images.length }}</strong> {{ images.length === 1 ? 'immagine' : 'immagini' }}</span>
              </div>
            </div>
            <div class="routing-view-toggle" role="group" aria-label="Modalità di visualizzazione">
              <button type="button"
                      class="view-toggle-btn"
                      [class.active]="imagesViewMode === 'grid'"
                      (click)="imagesViewMode = 'grid'"
                      title="Vista compatta a griglia">
                <i class="fas fa-th-large"></i>
                <span>Compatta</span>
              </button>
              <button type="button"
                      class="view-toggle-btn"
                      [class.active]="imagesViewMode === 'list'"
                      (click)="imagesViewMode = 'list'"
                      title="Vista lista, una sotto l'altra">
                <i class="fas fa-stream"></i>
                <span>Lista</span>
              </button>
            </div>
          </div>

          <!-- Vista compatta (griglia) -->
          <div class="images-grid" *ngIf="!isLoadingImages && images.length > 0 && imagesViewMode === 'grid'">
            <div class="image-card" *ngFor="let image of images" (click)="openImagePreview(image)">
              <div class="image-card-thumb">
                <img *ngIf="getImageSrc(image)" [src]="getImageSrc(image)"
                     [alt]="image.imageFileName || 'Immagine'" loading="lazy">
                <div class="image-card-placeholder" *ngIf="!getImageSrc(image)">
                  <i class="fas" [ngClass]="isPdf(image) ? 'fa-file-pdf' : 'fa-image'"></i>
                </div>
                <span class="image-type-badge">{{ getImageTypeLabel(image) }}</span>
              </div>
              <div class="image-card-info">
                <span class="image-card-name" [title]="image.imageFileName">{{ image.imageFileName || '-' }}</span>
                <span class="image-card-date" *ngIf="image.imageCreatedAt">
                  {{ image.imageCreatedAt | date:'dd/MM/yy HH:mm' }}
                </span>
              </div>
            </div>
          </div>

          <!-- Vista lista (una sotto l'altra) -->
          <div class="images-list" *ngIf="!isLoadingImages && images.length > 0 && imagesViewMode === 'list'">
            <div class="image-list-item" *ngFor="let image of images">
              <div class="image-list-preview" (click)="openImagePreview(image)"
                   [title]="isPdf(image) ? 'Apri il documento' : 'Apri l\'anteprima'">
                <img *ngIf="getImageSrc(image)" [src]="getImageSrc(image)"
                     [alt]="image.imageFileName || 'Immagine'" loading="lazy">
                <div class="image-card-placeholder" *ngIf="!getImageSrc(image)">
                  <i class="fas" [ngClass]="isPdf(image) ? 'fa-file-pdf' : 'fa-image'"></i>
                </div>
              </div>
              <div class="image-list-info">
                <div class="event-header">
                  <span class="event-title">{{ image.imageFileName || getImageTypeLabel(image) }}</span>
                  <span class="event-date" *ngIf="image.imageCreatedAt">
                    <i class="far fa-clock me-1"></i>
                    {{ image.imageCreatedAt | date:'dd/MM/yyyy HH:mm' }}
                  </span>
                </div>
                <div class="event-meta">
                  <span class="event-type-badge">{{ getImageTypeLabel(image) }}</span>
                  <span class="event-meta-item" *ngIf="image.imageSource">
                    <i class="fas fa-server"></i> {{ image.imageSource }}
                  </span>
                  <span class="event-meta-item" *ngIf="image.imageSizeBytes">
                    <i class="fas fa-weight-hanging"></i> {{ formatImageSize(image.imageSizeBytes) }}
                  </span>
                  <span class="event-meta-item" *ngIf="image.imageCreatedBy">
                    <i class="fas fa-user"></i> {{ image.imageCreatedBy }}
                  </span>
                </div>
                <div class="event-note" *ngIf="image.imageDescription">
                  <i class="fas fa-sticky-note me-1"></i>{{ image.imageDescription }}
                </div>
                <div class="image-list-actions">
                  <button type="button" class="image-action-btn"
                          (click)="downloadImage(image)"
                          title="Scarica il file">
                    <i class="fas fa-download text-primary"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Anteprima immagine -->
          <div class="image-preview-overlay" *ngIf="previewImage" (click)="closeImagePreview()">
            <div class="image-preview-content" (click)="$event.stopPropagation()">
              <div class="image-preview-header">
                <span class="image-preview-title">{{ previewImage.imageFileName || getImageTypeLabel(previewImage) }}</span>
                <div class="image-preview-actions">
                  <button type="button" class="image-action-btn"
                          (click)="downloadImage(previewImage)"
                          title="Scarica il file">
                    <i class="fas fa-download text-primary"></i>
                  </button>
                  <button type="button" class="image-action-btn"
                          (click)="closeImagePreview()"
                          title="Chiudi anteprima">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="image-preview-body">
                <img [src]="getImageSrc(previewImage)" [alt]="previewImage.imageFileName || 'Immagine'">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab: Webhook -->
      <div class="tab-content" *ngIf="activeTab === 'webhooks'">
        <div class="events-section">

          <!-- Loading state -->
          <div class="events-state-box" *ngIf="isLoadingWebhooks">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Caricamento...</span>
            </div>
            <p class="mt-3 text-muted mb-0">Caricamento webhook...</p>
          </div>

          <!-- Empty state -->
          <div class="events-state-box" *ngIf="!isLoadingWebhooks && webhooks.length === 0">
            <i class="fas fa-plug fa-3x text-muted mb-3"></i>
            <p class="text-muted mb-0">Nessun webhook disponibile per questa bolla.</p>
          </div>

          <!-- Header riepilogo -->
          <div class="events-summary" *ngIf="!isLoadingWebhooks && webhooks.length > 0">
            <div class="events-summary-item">
              <i class="fas fa-plug"></i>
              <span><strong>{{ webhooks.length }}</strong> webhook</span>
            </div>
            <div class="events-summary-item" *ngIf="webhooks[0].webhookCreatedAt">
              <i class="fas fa-clock"></i>
              <span>Ultimo webhook: <strong>{{ webhooks[0].webhookCreatedAt | date:'dd/MM/yyyy HH:mm' }}</strong></span>
            </div>
            <div class="events-summary-item webhook-summary-code" title="Codice bolla">
              <i class="fas fa-barcode"></i>
              <span>Bolla: <strong>{{ waybill?.waybillCode || displayCode }}</strong></span>
            </div>
            <div class="routing-view-toggle" role="group" aria-label="Modalità di visualizzazione">
              <button type="button"
                      class="view-toggle-btn"
                      [class.active]="webhooksViewMode === 'cards'"
                      (click)="webhooksViewMode = 'cards'"
                      title="Vista a card">
                <i class="fas fa-stream"></i>
                <span>Card</span>
              </button>
              <button type="button"
                      class="view-toggle-btn"
                      [class.active]="webhooksViewMode === 'table'"
                      (click)="webhooksViewMode = 'table'"
                      title="Vista a tabella">
                <i class="fas fa-table"></i>
                <span>Tabella</span>
              </button>
            </div>
          </div>

          <!-- Vista tabella -->
          <div class="webhook-table-wrapper" *ngIf="!isLoadingWebhooks && webhooks.length > 0 && webhooksViewMode === 'table'">
            <table class="table table-sm table-hover align-middle mb-0 webhook-table">
              <thead>
                <tr>
                  <th class="sortable" title="ID webhook" (click)="sortWebhooks('webhookId')">
                    ID <i class="fas" [ngClass]="getWebhookSortIcon('webhookId')"></i>
                  </th>
                  <th class="sortable" title="Tipo di webhook" (click)="sortWebhooks('webhookEventType')">
                    Tipo <i class="fas" [ngClass]="getWebhookSortIcon('webhookEventType')"></i>
                  </th>
                  <th class="sortable" title="Tipologia del dato" (click)="sortWebhooks('typeLabel')">
                    Tipologia <i class="fas" [ngClass]="getWebhookSortIcon('typeLabel')"></i>
                  </th>
                  <th class="sortable" title="Stato di elaborazione" (click)="sortWebhooks('webhookStatus')">
                    Stato <i class="fas" [ngClass]="getWebhookSortIcon('webhookStatus')"></i>
                  </th>
                  <th class="sortable" title="Tipo di affiliazione" (click)="sortWebhooks('webhookAffiliationType')">
                    Affiliazione <i class="fas" [ngClass]="getWebhookSortIcon('webhookAffiliationType')"></i>
                  </th>
                  <th class="sortable" title="Codice HTTP dell'ultima risposta" (click)="sortWebhooks('webhookLastResponseCode')">
                    HTTP <i class="fas" [ngClass]="getWebhookSortIcon('webhookLastResponseCode')"></i>
                  </th>
                  <th class="sortable" title="Numero di tentativi" (click)="sortWebhooks('webhookRetryCount')">
                    Tentativi <i class="fas" [ngClass]="getWebhookSortIcon('webhookRetryCount')"></i>
                  </th>
                  <th class="sortable" title="Data di arrivo" (click)="sortWebhooks('webhookCreatedAt')">
                    Arrivo <i class="fas" [ngClass]="getWebhookSortIcon('webhookCreatedAt')"></i>
                  </th>
                  <th class="sortable" title="Data di aggiornamento" (click)="sortWebhooks('webhookUpdatedAt')">
                    Aggiornamento <i class="fas" [ngClass]="getWebhookSortIcon('webhookUpdatedAt')"></i>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let webhook of sortedWebhooks">
                  <tr [class.webhook-row-error]="webhook.webhookLastProcessError"
                      [title]="webhook.webhookLastProcessError ? 'Ultimo errore: ' + webhook.webhookLastProcessError : ''">
                    <td>#{{ webhook.webhookId }}</td>
                    <td>
                      <i class="fas me-1" [ngClass]="getWebhookTypeIcon(webhook)"></i>
                      {{ webhook.webhookEventType || webhook.webhookName || '-' }}
                    </td>
                    <td>
                      <span class="webhook-type-badge" [ngClass]="getWebhookBadgeClass(webhook)"
                            *ngIf="getWebhookTypeLabel(webhook) as typeLabel; else noTypeLabel">
                        {{ typeLabel }}
                      </span>
                      <ng-template #noTypeLabel>-</ng-template>
                    </td>
                    <td>
                      <span class="event-status-badge" [ngClass]="getWebhookStatusClass(webhook)"
                            *ngIf="webhook.webhookStatus; else noValue">
                        <i class="fas fa-circle status-dot"></i>
                        {{ webhook.webhookStatus }}
                      </span>
                    </td>
                    <td>{{ webhook.webhookAffiliationType || '-' }}</td>
                    <td>{{ webhook.webhookLastResponseCode || '-' }}</td>
                    <td>{{ webhook.webhookRetryCount || 0 }}</td>
                    <td class="text-nowrap">{{ (webhook.webhookCreatedAt | date:'dd/MM/yyyy HH:mm:ss') || '-' }}</td>
                    <td class="text-nowrap">{{ (webhook.webhookUpdatedAt | date:'dd/MM/yyyy HH:mm:ss') || '-' }}</td>
                    <td class="text-end">
                      <button type="button" class="image-action-btn"
                              *ngIf="webhook.webhookContent || webhook.webhookContentResponse"
                              [title]="isWebhookExpanded(webhook) ? 'Nascondi il contenuto e la risposta del webhook' : 'Mostra il contenuto e la risposta del webhook'"
                              (click)="toggleWebhook(webhook)">
                        <i class="fas" [ngClass]="isWebhookExpanded(webhook) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="isWebhookExpanded(webhook)" class="webhook-row-detail">
                    <td colspan="10">
                      <div class="event-note webhook-error mt-0" *ngIf="webhook.webhookLastProcessError">
                        <i class="fas fa-exclamation-triangle me-1"></i>{{ webhook.webhookLastProcessError }}
                      </div>
                      <div class="webhook-content-block" *ngIf="webhook.webhookContent">
                        <div class="webhook-content-header">
                          <span>Contenuto</span>
                          <button type="button" class="image-action-btn"
                                  (click)="copyToClipboard(webhook.webhookContent || '')"
                                  title="Copia il contenuto">
                            <i class="fas fa-copy"></i>
                          </button>
                        </div>
                        <pre class="webhook-json">{{ formatWebhookJson(webhook.webhookContent) }}</pre>
                      </div>
                      <div class="webhook-content-block" *ngIf="webhook.webhookContentResponse">
                        <div class="webhook-content-header">
                          <span>Risposta</span>
                        </div>
                        <pre class="webhook-json">{{ formatWebhookJson(webhook.webhookContentResponse) }}</pre>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
            <ng-template #noValue>-</ng-template>
          </div>

          <!-- Lista webhook a card (il più recente in cima) -->
          <div class="events-timeline" *ngIf="!isLoadingWebhooks && webhooks.length > 0 && webhooksViewMode === 'cards'">
            <div class="event-item"
                 *ngFor="let webhook of webhooks; let i = index; let isLast = last"
                 [class.is-last]="isLast">

              <div class="event-marker">
                <div class="event-marker-dot" [ngClass]="getWebhookVariantClass(webhook)"
                     [title]="(getWebhookTypeLabel(webhook) || 'Webhook') + ' — stato: ' + (webhook.webhookStatus || '-')">
                  <i class="fas" [ngClass]="getWebhookTypeIcon(webhook)"></i>
                </div>
                <div class="event-connector" *ngIf="!isLast"></div>
              </div>

              <div class="event-body">
                <div class="event-header webhook-header">
                  <span class="event-title" title="Tipo di webhook">
                    {{ webhook.webhookEventType || webhook.webhookName || 'Webhook' }}
                    <span class="event-raw-name" title="ID webhook">#{{ webhook.webhookId }}</span>
                  </span>
                  <span class="webhook-type-badge"
                        [ngClass]="getWebhookBadgeClass(webhook)"
                        [title]="'Tipologia del dato — stato: ' + (webhook.webhookStatus || '-')"
                        *ngIf="getWebhookTypeLabel(webhook) as typeLabel">
                    <i class="fas me-1" [ngClass]="getWebhookTypeIcon(webhook)"></i>{{ typeLabel }}
                  </span>
                  <div class="webhook-dates">
                    <span class="event-date" *ngIf="webhook.webhookCreatedAt" title="Data di arrivo">
                      <i class="far fa-clock me-1"></i>
                      {{ webhook.webhookCreatedAt | date:'dd/MM/yyyy HH:mm:ss' }}
                    </span>
                    <span class="event-date" *ngIf="webhook.webhookUpdatedAt" title="Data di aggiornamento">
                      <i class="fas fa-sync-alt me-1"></i>
                      {{ webhook.webhookUpdatedAt | date:'dd/MM/yyyy HH:mm:ss' }}
                    </span>
                  </div>
                </div>
                <div class="event-meta">
                  <span class="event-status-badge" [ngClass]="getWebhookStatusClass(webhook)"
                        *ngIf="webhook.webhookStatus" title="Stato di elaborazione">
                    <i class="fas fa-circle status-dot"></i>
                    {{ webhook.webhookStatus }}
                  </span>
                  <span class="event-type-badge" *ngIf="webhook.webhookAffiliationType" title="Tipo di affiliazione">
                    {{ webhook.webhookAffiliationType }}
                  </span>
                  <span class="event-meta-item" *ngIf="webhook.webhookLastResponseCode" title="Codice HTTP dell'ultima risposta">
                    <i class="fas fa-reply"></i> HTTP {{ webhook.webhookLastResponseCode }}
                  </span>
                  <span class="event-meta-item" *ngIf="webhook.webhookRetryCount" title="Numero di tentativi">
                    <i class="fas fa-redo"></i> {{ webhook.webhookRetryCount }} tentativi
                  </span>
                  <span class="event-meta-item" *ngIf="webhook.webhookUpdatedBy" title="Aggiornato da">
                    <i class="fas fa-user"></i> {{ webhook.webhookUpdatedBy }}
                  </span>
                </div>
                <div class="event-note" *ngIf="webhook.webhookDescription" title="Descrizione">
                  <i class="fas fa-sticky-note me-1"></i>{{ webhook.webhookDescription }}
                </div>
                <div class="event-note webhook-error" *ngIf="webhook.webhookLastProcessError" title="Ultimo errore di elaborazione">
                  <i class="fas fa-exclamation-triangle me-1"></i>{{ webhook.webhookLastProcessError }}
                  <span class="text-muted" *ngIf="webhook.webhookLastProcessErrorAt" title="Data dell'errore">
                    ({{ webhook.webhookLastProcessErrorAt | date:'dd/MM/yyyy HH:mm' }})
                  </span>
                </div>
                <button type="button" class="event-note-toggle mt-2"
                        *ngIf="webhook.webhookContent || webhook.webhookContentResponse"
                        [title]="isWebhookExpanded(webhook) ? 'Nascondi il contenuto e la risposta del webhook' : 'Mostra il contenuto e la risposta del webhook'"
                        (click)="toggleWebhook(webhook)">
                  {{ isWebhookExpanded(webhook) ? 'Nascondi contenuto' : 'Mostra contenuto' }}
                </button>
                <ng-container *ngIf="isWebhookExpanded(webhook)">
                  <div class="webhook-content-block" *ngIf="webhook.webhookContent">
                    <div class="webhook-content-header">
                      <span>Contenuto</span>
                      <button type="button" class="image-action-btn"
                              (click)="copyToClipboard(webhook.webhookContent || '')"
                              title="Copia il contenuto">
                        <i class="fas fa-copy"></i>
                      </button>
                    </div>
                    <pre class="webhook-json">{{ formatWebhookJson(webhook.webhookContent) }}</pre>
                  </div>
                  <div class="webhook-content-block" *ngIf="webhook.webhookContentResponse">
                    <div class="webhook-content-header">
                      <span>Risposta</span>
                    </div>
                    <pre class="webhook-json">{{ formatWebhookJson(webhook.webhookContentResponse) }}</pre>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab: Barcode/QR -->
      <div class="tab-content" *ngIf="activeTab === 'barcode'">
        <div class="waybill-details">

          <div class="routing-toolbar">
            <div class="routing-summary">
              <div class="routing-summary-item">
                <i class="fas" [ngClass]="codeType === 'barcode' ? 'fa-barcode' : 'fa-qrcode'"></i>
                <span>Codice da scansionare: <strong>{{ displayCode }}</strong></span>
              </div>
            </div>
            <div class="routing-view-toggle" role="group" aria-label="Tipo di codice">
              <button type="button"
                      class="view-toggle-btn"
                      [class.active]="codeType === 'barcode'"
                      (click)="setCodeType('barcode')"
                      title="Barcode lineare">
                <i class="fas fa-barcode"></i>
                <span>Barcode</span>
              </button>
              <button type="button"
                      class="view-toggle-btn"
                      [class.active]="codeType === 'qrcode'"
                      (click)="setCodeType('qrcode')"
                      title="QR Code">
                <i class="fas fa-qrcode"></i>
                <span>QR Code</span>
              </button>
            </div>
          </div>

          <div class="details-card">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas" [ngClass]="codeType === 'barcode' ? 'fa-barcode' : 'fa-qrcode'"></i>
              </div>
              <h5 class="details-card-title">
                {{ codeType === 'barcode' ? 'Barcode' : 'QR Code' }}
              </h5>
            </div>
            <div class="details-card-body">
              <div class="barcode-canvas-wrap">
                <canvas #barcodeCanvas *ngIf="codeType === 'barcode'"></canvas>
                <canvas #qrcodeCanvas *ngIf="codeType === 'qrcode'"></canvas>
              </div>
            </div>
          </div>

          <div class="details-card">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-info-circle"></i>
              </div>
              <h5 class="details-card-title">Informazioni Codice</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item">
                  <span class="details-label">Codice Bolla</span>
                  <div class="details-value details-value--code">
                    <span>{{ displayCode }}</span>
                    <i class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(displayCode)"
                       title="Copia codice bolla"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Tab: Mappa -->
      <div class="tab-content" *ngIf="activeTab === 'map'">
        <div class="waybill-details">

          <!-- Stato: coordinate mancanti -->
          <ng-container *ngIf="!hasValidCoordinates()">
            <div class="details-card">
              <div class="details-card-header">
                <div class="details-card-icon"
                     style="background: linear-gradient(135deg, #6c757d, #5c636a); box-shadow: 0 2px 6px rgba(108, 117, 125, 0.25);">
                  <i class="fas fa-map-marked-alt"></i>
                </div>
                <h5 class="details-card-title">Posizione Geografica</h5>
              </div>
              <div class="details-card-body">
                <div class="routing-state-box">
                  <i class="fas fa-map-marker-slash fa-3x text-muted mb-3"></i>
                  <p class="mb-1 fw-semibold">Coordinate mancanti</p>
                  <p class="text-muted mb-0 small">
                    Non sono disponibili le coordinate geografiche del destinatario per visualizzare la mappa.
                  </p>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Mappa + alert quando coordinate presenti -->
          <ng-container *ngIf="hasValidCoordinates()">
            <div class="details-card"
                 [class.is-delivered]="isDelivered() && hasDeliveryCoordinates() && isDeliveryWithinRadius()">
              <div class="details-card-header">
                <div class="details-card-icon">
                  <i class="fas fa-map-marked-alt"></i>
                </div>
                <h5 class="details-card-title">
                  Posizione Geografica
                  <span class="details-card-tag"
                        *ngIf="isDelivered() && hasDeliveryCoordinates() && isDeliveryWithinRadius()">
                    <i class="fas fa-check me-1"></i>Consegnato
                  </span>
                </h5>
              </div>
              <div class="details-card-body p-0">
                <div class="map-container" #mapContainer></div>
              </div>
            </div>

            <!-- Consegnato entro il raggio -->
            <div class="details-alert details-alert--success"
                 *ngIf="isDelivered() && hasDeliveryCoordinates() && isDeliveryWithinRadius()">
              <div class="details-alert-icon">
                <i class="fas fa-check-circle"></i>
              </div>
              <div class="details-alert-body">
                <div class="details-alert-title">Consegna Confermata</div>
                <div class="details-alert-text">
                  La bolla è stata consegnata correttamente entro il raggio di
                  <strong>{{ this.client?.clientMaximumRange }}m</strong> dalla destinazione.
                </div>
                <div class="details-alert-meta">
                  <span class="details-status-badge status-executed">
                    <i class="fas fa-circle status-dot"></i>
                    {{ (getDistanceFromDestination() || 0).toFixed(0) }}m dalla destinazione
                  </span>
                </div>
              </div>
            </div>

            <!-- Consegnato fuori raggio -->
            <div class="details-alert details-alert--warning"
                 *ngIf="isDelivered() && hasDeliveryCoordinates() && !isDeliveryWithinRadius()">
              <div class="details-alert-icon">
                <i class="fas fa-exclamation-triangle"></i>
              </div>
              <div class="details-alert-body">
                <div class="details-alert-title">Consegnato fuori raggio</div>
                <div class="details-alert-text">
                  La bolla è stata consegnata ma la posizione è
                  <strong>fuori dal raggio di {{ this.client?.clientMaximumRange }}m</strong> dalla destinazione.
                </div>
                <div class="details-alert-meta">
                  <span class="details-status-badge status-pending">
                    <i class="fas fa-circle status-dot"></i>
                    {{ (getDistanceFromDestination() || 0).toFixed(0) }}m dalla destinazione
                  </span>
                </div>
              </div>
            </div>

            <!-- Non consegnato -->
            <div class="details-alert"
                 *ngIf="!isDelivered()"
                 [ngClass]="hasDeliveryCoordinates() && !isDeliveryWithinRadius() ? 'details-alert--danger' : 'details-alert--warning'">
              <div class="details-alert-icon">
                <i class="fas"
                   [ngClass]="hasDeliveryCoordinates() && !isDeliveryWithinRadius() ? 'fa-times-circle' : 'fa-exclamation-triangle'"></i>
              </div>
              <div class="details-alert-body">
                <div class="details-alert-title">In attesa di consegna</div>
                <div class="details-alert-text">
                  <span *ngIf="!hasDeliveryCoordinates()">La bolla non è ancora stata consegnata.</span>
                  <span *ngIf="hasDeliveryCoordinates() && isDeliveryWithinRadius()">
                    La bolla non è ancora stata consegnata, ma la posizione attuale è
                    <strong>nel raggio di {{ this.client?.clientMaximumRange }}m</strong>.
                  </span>
                  <span *ngIf="hasDeliveryCoordinates() && !isDeliveryWithinRadius()">
                    La bolla non è ancora stata consegnata e la posizione attuale è
                    <strong>fuori dal raggio di {{ this.client?.clientMaximumRange }}m</strong> dalla destinazione.
                  </span>
                </div>
                <div class="details-alert-meta" *ngIf="hasDeliveryCoordinates()">
                  <span class="details-status-badge"
                        [ngClass]="isDeliveryWithinRadius() ? 'status-in-progress' : 'status-failed'">
                    <i class="fas fa-circle status-dot"></i>
                    {{ (getDistanceFromDestination() || 0).toFixed(0) }}m dalla destinazione
                  </span>
                </div>
              </div>
            </div>
          </ng-container>

        </div>
      </div>

      <!-- Tab: Funzionalità -->
      <div class="tab-content" *ngIf="activeTab === 'functions'">
        <div class="waybill-details">

          <div class="routing-toolbar">
            <div class="routing-summary">
              <div class="routing-summary-item">
                <i class="fas fa-cogs"></i>
                <span>Azioni disponibili sulla bolla</span>
              </div>
            </div>
          </div>

          <div class="details-card">
            <div class="details-card-body">
              <div class="functions-grid">

                <!-- Stampa Etichette -->
                <div class="function-card variant-primary"
                     (click)="printLabels()"
                     *ngIf="allParcels && allParcels.length > 0">
                  <div class="function-card-icon">
                    <i class="fas fa-tags"></i>
                  </div>
                  <div class="function-card-text">
                    <h6 class="function-card-title">Stampa Etichette</h6>
                    <p class="function-card-desc">
                      Genera e scarica le etichette di tutti i colli della bolla ({{ allParcels.length }} colli)
                    </p>
                  </div>
                  <div class="function-card-action">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>

                <!-- Stampa Documento Bolla -->
                <div class="function-card variant-primary" (click)="printWaybill()">
                  <div class="function-card-icon">
                    <i class="fas fa-file-pdf"></i>
                  </div>
                  <div class="function-card-text">
                    <h6 class="function-card-title">Stampa Documento Bolla</h6>
                    <p class="function-card-desc">Genera e scarica il documento PDF completo della bolla</p>
                  </div>
                  <div class="function-card-action">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>

                <!-- Stampa Documento POD -->
                <div class="function-card variant-primary" (click)="printPod()">
                  <div class="function-card-icon">
                    <i class="fas fa-file-signature"></i>
                  </div>
                  <div class="function-card-text">
                    <h6 class="function-card-title">Stampa Documento POD</h6>
                    <p class="function-card-desc">Genera e scarica il documento POD (prova di consegna) della bolla</p>
                  </div>
                  <div class="function-card-action">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>

                <!-- Invia in Axylog -->
                <div class="function-card variant-info" (click)="sendToAxylog()">
                  <div class="function-card-icon">
                    <i class="fas fa-paper-plane"></i>
                  </div>
                  <div class="function-card-text">
                    <h6 class="function-card-title">Invia in Axylog</h6>
                    <p class="function-card-desc">Sincronizza i dati della bolla con il sistema Axylog</p>
                  </div>
                  <div class="function-card-action">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>

                <!-- Invia via Mail -->
                <div class="function-card variant-info" (click)="sendByEmail()">
                  <div class="function-card-icon">
                    <i class="fas fa-envelope"></i>
                  </div>
                  <div class="function-card-text">
                    <h6 class="function-card-title">Invia via Mail</h6>
                    <p class="function-card-desc">Invia i dettagli e la documentazione della bolla via email</p>
                  </div>
                  <div class="function-card-action">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>

                <!-- Invia TrackingCode -->
                <div class="function-card variant-success"
                     [class.is-disabled]="!hasEmailsInNotes()"
                     [attr.title]="!hasEmailsInNotes() ? 'Nessuna email trovata nelle note della bolla' : ''">
                  <div class="function-card-icon">
                    <i class="fas fa-share-square"></i>
                  </div>
                  <div class="function-card-text">
                    <h6 class="function-card-title">Invia TrackingCode</h6>
                    <p class="function-card-desc" *ngIf="hasEmailsInNotes()">
                      Condividi il codice di tracciamento ({{ trackingEmails.length }} email
                      {{ trackingEmails.length === 1 ? 'configurata' : 'configurate' }})
                    </p>
                    <p class="function-card-desc text-muted" *ngIf="!hasEmailsInNotes()">
                      <i class="fas fa-exclamation-circle me-1"></i>
                      Nessuna email trovata nelle note della bolla
                    </p>
                  </div>
                  <div class="function-card-actions">
                    <button type="button"
                            class="fn-action-btn"
                            (click)="openEmailManager(); $event.stopPropagation();"
                            [disabled]="!hasEmailsInNotes()"
                            title="Gestisci email per il tracking code">
                      <i class="fas fa-at"></i>
                    </button>
                    <button type="button"
                            class="fn-action-btn fn-action-btn--primary"
                            (click)="hasEmailsInNotes() && sendTrackingCode(); $event.stopPropagation();"
                            [disabled]="!hasEmailsInNotes() || trackingEmails.length === 0"
                            title="Invia tracking code">
                      <i class="fas fa-paper-plane"></i>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-secondary" (click)="close()">
          <i class="fas fa-times me-2"></i>
          Chiudi
        </button>
      </div>
    </div>
  </div>

  <!-- Email Manager Popup (nested) -->
  <div class="email-manager-overlay" [class.show]="isEmailManagerVisible" (click)="closeEmailManager()">
    <div class="email-manager-content" (click)="$event.stopPropagation()">
      <div class="email-manager-header">
        <h5 class="email-manager-title">
          <i class="fas fa-at me-2"></i>
          Gestisci Email per TrackingCode
        </h5>
        <button type="button" class="btn-close-manager" (click)="closeEmailManager()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="email-manager-body">
        <!-- Info bolla -->
        <div class="manager-info-section">
          <div class="info-item">
            <i class="fas fa-file-invoice me-2"></i>
            <strong>Bolla:</strong> {{ waybill?.waybillCode || '-' }}
          </div>
        </div>

        <!-- Sezione aggiunta email -->
        <div class="add-email-section">
          <label class="form-label">Aggiungi nuova email</label>
          <div class="input-group">
            <input 
              type="email" 
              class="form-control" 
              [(ngModel)]="newEmailInput"
              (keypress)="onEmailKeyPress($event)"
              placeholder="Inserisci indirizzo email"
              [class.is-invalid]="newEmailInput && !isValidEmail(newEmailInput)">
            <button 
              type="button" 
              class="btn btn-primary" 
              (click)="addEmail()"
              [disabled]="!newEmailInput.trim() || !isValidEmail(newEmailInput.trim())">
              <i class="fas fa-plus me-1"></i>
              Aggiungi
            </button>
          </div>
          <div class="invalid-feedback" *ngIf="newEmailInput && !isValidEmail(newEmailInput)">
            Inserisci un indirizzo email valido
          </div>
        </div>

        <!-- Lista email -->
        <div class="emails-list-section">
          <h6 class="section-subtitle">
            <i class="fas fa-envelope me-2"></i>
            Email configurate ({{ trackingEmails.length }})
          </h6>
          
          <div class="emails-list" *ngIf="trackingEmails.length > 0">
            <div class="email-item" *ngFor="let email of trackingEmails; let i = index">
              <span class="email-text">
                <i class="fas fa-envelope me-2"></i>
                {{ email }}
              </span>
              <button 
                type="button" 
                class="btn-remove-email"
                (click)="removeEmail(i)"
                title="Rimuovi email">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>

          <div class="no-emails-message" *ngIf="trackingEmails.length === 0">
            <i class="fas fa-inbox me-2"></i>
            Nessuna email configurata
          </div>
        </div>
      </div>

      <div class="email-manager-footer">
        <button type="button" class="btn btn-secondary" (click)="closeEmailManager()">
          <i class="fas fa-check me-1"></i>
          Fatto
        </button>
      </div>
    </div>
  </div>
</div>
